export const SESSION_STORAGE_KEY = {
    adminUIPath: 'adminUIPath',
    adminUIContextId: 'adminUIContextId'
}